import React from 'react';
import { StyledPageLink } from './Paginator.styled';

export const PagesLink = ({
        onClick,
        disabled,
        src,
        alt,
        width,
        height,
        position='relative',
        margin}) => {
    return <StyledPageLink
                onClick={onClick}
                disabled={disabled}
                position={position}
                margin={margin}
            >
                <img
                    src={src}
                    alt={alt}
                    width={width}
                    height={height}
                />
            </StyledPageLink>;
};

export default PagesLink;